const REFMODEL_MESH_THRESHOLD = 1000; // the max surface count of model
const REFMODEL_SIZE_THRESHOLD = 150e6; // the max size of model gltf in bytes

const withExceedsLimits = (entity) => {
  const exceedsLimits = (entity.surfacesCount > REFMODEL_MESH_THRESHOLD) || (entity.gltfSize > REFMODEL_SIZE_THRESHOLD);
  return { ...entity, exceedsLimits };
};

export { withExceedsLimits };
